import { Container, Row, Col, Nav } from "react-bootstrap";
import { Calendar } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-custom py-5">
      <Container>
        <Row className="align-items-center justify-content-between g-4">
          {/* Logo */}
          <Col xs={12} md="auto" className="text-center text-md-start">
            <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-2">
              <div className="icon-box-sm gradient-primary d-flex align-items-center justify-content-center shadow-soft">
                <Calendar size={18} color="white" />
              </div>
              <span className="fw-bold fs-5">AgendaFácil</span>
            </div>
          </Col>

          {/* Links */}
          <Col xs={12} md="auto">
            <Nav className="justify-content-center gap-4">
              <Nav.Link href="#servicos" className="text-white-50 small">Serviços</Nav.Link>
              <Nav.Link href="#sobre" className="text-white-50 small">Sobre</Nav.Link>
              <Nav.Link href="#contato" className="text-white-50 small">Contato</Nav.Link>
            </Nav>
          </Col>

          {/* Copyright */}
          <Col xs={12} md="auto" className="text-center text-md-end">
            <small className="text-white-50">
              © {currentYear} AgendaFácil. Todos os direitos reservados.
            </small>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;